import type { Country } from 'client-localisation/constants/countries';
import { countries } from 'client-localisation/constants/countries';

export const getCountry = (code: Country['countryCode']) =>
  countries.find(({ countryCode }) => countryCode === code);
